'use client';
import React from 'react';
import { Button } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

export interface BudgetCalculatorProps {
  title: string;
  calculator_link: string;
}

export const BudgetCalculator: React.FC<BudgetCalculatorProps> = ({ calculator_link, title }) => {
  const [necessities, setNecessities] = React.useState(0);
  const [wants, setWants] = React.useState(0);
  const [saving, setSaving] = React.useState(0);
  const onIncomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const amount = Number(e.target.value);
    setNecessities(amount * 0.5);
    setWants(amount * 0.3);
    setSaving(amount * 0.2);
  };

  return (
    <BudgetCalculatorContainer>
      <div className="flex max-w-[750px]">
        <div className="wrap-block flex-col bg-white border border-t-4 shadow-sm rounded-xl">
          <div className="p-4 md:p-5">
            <h3 className="text-lg font-bold text-gray-800">{title}</h3>
            <p className="mt-2 text-gray-500">
              Our 50/30/20 calculator divides your take-home income into suggested spending in three categories: 50% of
              net pay for needs, 30% for wants and 20% for savings and debt repayment.
            </p>
            <div className="input-container flex flex-col">
              <label>Monthly after-tax income</label>
              <input
                className="border p-2 w-2/3 rounded"
                onChange={onIncomeChange}
                placeholder="Enter Your income"
                required
                type="text"
              />
            </div>
            <div className="flex flex-col md:flex-row justify-between mt-5">
              <div className="result-node flex-col mb-4">
                <h5>Necessities</h5>
                <div className="price-item">${necessities.toLocaleString()}</div>
              </div>
              <div className="result-node flex-col mb-4">
                <h5>Wants</h5>
                <div className="price-item">${wants.toLocaleString()}</div>
              </div>
              <div className="result-node flex-col mb-4">
                <h5>Saving & Debt</h5>
                <div className="price-item">${saving.toLocaleString()}</div>
              </div>
            </div>
            <p className="mt-2 text-gray-500">
              If you have more complex finances and want a custom plan made for your lifestyle and financial goals,
              Benzinga recommends finding a vetted financial advisor to consult. You can fill out a free questionnaire
              to help you match today!
            </p>
            {calculator_link && (
              <div className="action-btn">
                <Button as="a" href={calculator_link} size="md" variant="flat-orange">
                  Get Started
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </BudgetCalculatorContainer>
  );
};

export const BudgetCalculatorContainer = styled.div`
  .wrap-block {
    border-top-color: ${({ theme }) => theme.colorPalette.orange500};
  }
  .result-node {
    .price-item {
      font-size: 2rem;
    }
  }
  .action-btn {
    a {
      padding: 0.75rem 1rem;
    }
  }
`;
